
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 72 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#024FA2","d":"M0 0h72v36H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 6h72v24H0z"}}),_c('path',{attrs:{"fill":"#ED1C27","d":"M0 7h72v22H0z"}}),_c('circle',{attrs:{"fill":"#fff","cx":"24","cy":"18","r":"8"}}),_c('g',{attrs:{"transform":"matrix(7.75 0 0 7.75 24 18)","fill":"#ED1C27"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","transform":"rotate(18 3.157 -.5)","d":"M0 0v1h.5z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-144)"}})])])
          )
        }
      }
    